<template>
	  <div id="app">
	    <router-view/>
	  </div>
</template>

<script>
		export default {
		  name: 'App'
		}
</script>

<style>
		#app {
		  	font-family: Helvetica, Arial, 'Avenir', sans-serif;
		  	-webkit-font-smoothing: antialiased;
		  	-moz-osx-font-smoothing: grayscale;
		  	color: #2c3e50;
		  	position:relative;
	  		height:100%;
		}
</style>



// WEBPACK FOOTER //
// src/App.vue